import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import { ExportDataButtonProps } from 'types/componentTypes';
import { exportTableDataAsExcel } from 'packages/settings_repository';
import {
  isServiceProvider,
  isStartup,
  isAngelInvestor,
} from 'utils';

const ExportDataButton = (props: ExportDataButtonProps) => {
  const { exportDataModel, showExportButton, user } = props;

  if (!showExportButton || !exportDataModel) {
    return null;
  }

  const onHandleClick = () => {
    let query = '';

    if (user) {
      const {
        serviceProviderId,
        startupId,
        angelInvestorId,
        userType,
      } = user;

      if (isStartup(userType)) {
        query = `startup_id=${startupId}`;
      }

      if (isAngelInvestor(userType)) {
        query = `angel_investor_id=${angelInvestorId}`;
      }

      if (isServiceProvider(userType)) {
        query = `serviceProviderId=${serviceProviderId}`;
      }
    }

    exportTableDataAsExcel(exportDataModel, query);
  };

  return (
    <div className="table-export-button__container">
      <Button
        type="link"
        className="export-button"
        onClick={onHandleClick}
        color="primary"
      >
        <DownloadOutlined color="white" />
        Download Report
      </Button>
    </div>
  )
};

export default ExportDataButton;
